import React, { useState } from 'react';
import { saveAsyncDeliverRecord, fetchAsyncDeliveryRecord } from 'lib/apis';
import awardPrizeService from 'lib/services/awardPrizeService';
import { AWARD_TYPES } from 'lib/constants/award';
import { ReceiveGiftRequestData } from 'lib/apis/model/gift';
import { report } from 'lib/utils/dataReport';
import { ATTA_REPORT } from 'lib/constants/atta';
import { handleCMCCPrizeReceive } from '../ReceiveDialog/helper';
import Dialog from '../Dialog';

const AsyncDeliverDialog = ({ data }) => {
  const [isCheck, setIsCheck] = useState(false);
  const giftList = awardPrizeService.getAllGiftData();

  const checkConfirm = () => {
    setIsCheck((c) => !c);
  };

  const submit = async () => {
    let actIds = [+data.actId];
    // 先查询一下是否已经保存过异步发奖记录
    if (isCheck) {
      /**
       * 1、过滤抽奖礼包 3是抽奖礼包
       * 2、查询活动ID
       */
      const activityList = giftList
        // 1表示安慰礼包(普通礼包) 3表示抽奖礼包
        .filter((c) => c.actId && c.giftType !== AWARD_TYPES.LOTTERY && c.giftType !== AWARD_TYPES.NORMAL)
        .map((item) => item.actId);
      const res = await Promise.all([...activityList.map((item) => fetchAsyncDeliveryRecord({ actId: item }))]);
      actIds = activityList.filter((item, index) => {
        if (res[index]?.code === 0 && !res[index]?.data?.roleId) {
          return item;
        }
      });
    }

    report(ATTA_REPORT.ASYNC_DELIVER.ASYNC_DELIVER_AUTH_CLICK, {
      is_all: Number(isCheck),
    });
    actIds.length && (await saveAsyncDeliverRecord({ ...data, actIds }));
    handleCMCCPrizeReceive(data.mobile, data.gameId, {
      isAuto: true,
      roleInfo: `${data.partitionName ? `${data.partitionName}-` : ''}${data.roleName}`,
      isOverYear: data.isOverYear,
    });
  };

  const close = () => {
    report(ATTA_REPORT.ASYNC_DELIVER.AYSNC_DELIVER_CLOSE_CLICK);
    handleCMCCPrizeReceive(data.mobile, data.gameId, {
      isOverYear: data.isOverYear,
    });
  };

  return (
    <Dialog title="开启本月自动领取" closeCallback={close} keyboard={{ onEnter: submit }}>
      <div className="receive-dialog">
        <div className="receive-dialog__content">
          <div className="content-title">
            目前暂未查询到运营商侧同步的领奖资格信息，您可点击下方按钮申请领取礼包，在收到相关资格推送时我们将为您自动下发礼包
            <span>（权益类商品会为您自动抽取后发放）</span>
          </div>
        </div>
        {
          <div className="footer-confirm" onClick={checkConfirm}>
            <div className={`footer-confirm__checkbox ${isCheck ? 'checked' : ''}`}></div>
            <div className="footer-confirm__text">同时自动下发所有剩余礼包（除抽奖礼包）</div>
          </div>
        }

        <div className="receive-dialog__footer">
          <div className="footer-btn confirm" onClick={submit}>
            领奖资格到账时自动为我下发礼包
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export const showAsyncDeliverDialog = (params: ReceiveGiftRequestData) => (
  // report(ATTA_REPORT.ASYNC_DELIVER.ASYNC_DELIVER_VIEW);
  <AsyncDeliverDialog data={params} />
);

export default AsyncDeliverDialog;
